import { render, staticRenderFns } from "./employeeData.vue?vue&type=template&id=35213e21&scoped=true&"
import script from "./employeeData.vue?vue&type=script&lang=js&"
export * from "./employeeData.vue?vue&type=script&lang=js&"
import style0 from "./employeeData.vue?vue&type=style&index=0&id=35213e21&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35213e21",
  null
  
)

export default component.exports